export class Result<T> {
  /**
   * 请求是否成功
   */
  isSucc!: boolean;
  /**
   * 状态码
   */
  statusCode!: string;
  /**
   * 返回消息
   */
  message?: string;
  /**
   * 返回结果
   */
  result?: T;
}

export class PageList<T> {
  /**
   * 页码
   */
  pageNo?: number;

  /**
   * 每页条数
   */
  pageSize?: number;

  /**
   * 分页总数
   */
  pageCount?: number;

  /**
   * 记录总数
   */
  recordCount?: number;

  /**
   * 数据实体
   */
  entities?: T[];
}

export class SigninModel {
  ///<summary>用户账户
  ///</summary>
  UserAct?: string;

  ///<summary>用户密码
  ///</summary>
  UserPwd?: string;

  ValidID?: string;
  ///<summary>验证码
  ///</summary>
  ValidCode?: string;

  ///<summary>是否记住密码
  ///</summary>
  IsRemember?: boolean;
  DeviceInfo?: string;
  DeviceCode?: string;
  AppKey?: string;
  LoginMode?: number;
  ReferID?: string;
  LoginCodes?: string;
}
export class SignupModel extends SigninModel {
  /**
   * 用户名称
   */
  userName: string | undefined;
}

export class UserModel {
  ///<summary>用户编号
  ///</summary>
  UserID?: string;
  ///<summary>用户名称
  ///</summary>
  UserName?: string;
  ///<summary>用户昵称
  ///</summary>
  UserNick?: string;
  ///<summary>用户头像
  ///</summary>
  UserIcon?: string;
  ///<summary>用户性别
  ///</summary>
  UserSex?: number;

  ///<summary>联系电话
  ///</summary>
  ContactMobile?: string;

  ///<summary>联系邮箱
  ///</summary>
  ContactEmail?: string;

  ///<summary>公司编号
  ///</summary>
  CompanyID?: string;

  ///<summary>公司名称
  ///</summary>
  CompanyName?: string;

  ///<summary>公司简称
  ///</summary>
  CompanyNick?: string;

  ///<summary>部门编号
  ///</summary>
  DepartmentID?: string;

  ///<summary>部门名称
  ///</summary>
  DepartmentName?: string;

  /// <summary> 空间编号
  /// </summary>
  SpaceID?: string;

  ///<summary>级别代码
  ///</summary>
  LevelCode?: string[];
  Confers?: ConferModel[];
  DataRange?: number;

  ///<summary>特性代码
  ///</summary>
  FeatureCodes?: string[];

  ///<summary>代理编号
  ///</summary>
  AgentID?: string;
  ///<summary>代理名称
  ///</summary>
  AgentName?: string;
}

export class UserAccountEntity {
  ///<summary>用户编号
  ///</summary>
  UserID?: string;
  ///<summary>用户账户
  ///</summary>
  UserAct?: string;
  ///<summary>用户密码
  ///</summary>
  UserPwd?: string;
  ///<summary>用户状态
  ///</summary>
  AccountStatus?: number;
  AppID?: string;
  ///<summary>授权方式
  ///</summary>
  AuthType?: number;
  ///<summary>创建人
  ///</summary>
  CreaterID?: string;
  ///<summary>创建时间
  ///</summary>
  CreateTime?: Date;
  CreateTimeEnd?: Date;
  ///<summary>修改人
  ///</summary>
  UpdaterID?: string;
  ///<summary>修改时间
  ///</summary>
  UpdateTime?: Date;
  UpdateTimeEnd?: Date;
  ///<summary>备注
  ///</summary>
  Remark?: string;

  /**重置密码时需要使用 */
  ConfirmPwd?: string;
  ValidCode?: string;
  MobileCode?: number;
}
export class UserAccountModel extends UserAccountEntity {
  Code?: string;
  ValidType?: string;
}

export class ProfileInfo extends UserModel {
  ///<summary>用户名称
  ///</summary>
  UserAct?: string;

  ///<summary>凭证编号
  ///</summary>
  TicketID?: string;

  Duration?: number;
  LoginTime?: Date;
  TimeOut?: Date;
}
export class ConferModel {
  ConferCode?: string;
  SpaceID?: string;
  ConferTo?: string;
}

export class RoleInfoEntity {
  ///<summary>角色编号
  ///</summary>
  RoleID?: string;
  ///<summary>角色名称
  ///</summary>
  RoleName?: string;
  ///<summary>别名
  ///</summary>
  RoleNick?: string;
  ///<summary>角色类型
  ///</summary>
  RoleType?: number;
  ///<summary>角色状态
  ///</summary>
  RoleStatus?: number;
  ///<summary>组织编号
  ///</summary>
  RootID?: string;
  ///<summary>级别代码
  ///</summary>
  LevelCode?: string;
  ///<summary>角色头像
  ///</summary>
  RoleIcon?: string;
  ///<summary>角色类型
  ///</summary>
  RoleGenre?: number;
  ///<summary>诞生日期
  ///</summary>
  BirthDate?: Date;
  BirthDateEnd?: Date;
  ///<summary>联系编号
  ///</summary>
  ContactID?: string;
  ///<summary>用户国籍
  ///</summary>
  Country?: number;
  ///<summary>英文姓氏
  ///</summary>
  FirstName?: string;
  ///<summary>英文名称
  ///</summary>
  LastName?: string;
  ///<summary>创建人
  ///</summary>
  CreaterID?: string;
  ///<summary>创建时间
  ///</summary>
  CreateTime?: Date;
  CreateTimeEnd?: Date;
  ///<summary>修改人
  ///</summary>
  UpdaterID?: string;
  ///<summary>修改时间
  ///</summary>
  UpdateTime?: Date;
  UpdateTimeEnd?: Date;
  ///<summary>备注
  ///</summary>
  Remark?: string;
  ///<summary>简介
  ///</summary>
  RoleIntro?: string;
  // 预算编码
  BudgetCode?: string;
  // 预算描述
  BudgetIntro?: string;
  // 预算名称
  BudgetName?:string
}

export class ContactInfoEntity {
  ContactID?: string;
  RoleID?: string;
  ///<summary>地址简称
  ///</summary>
  ContactName?: string;
  ///<summary>联系人名称
  ///</summary>
  ContactPeople?: string;
  ContactPhone?: string;
  ///<summary>联系人邮箱
  ///</summary>
  ContactEmail?: string;
  ///<summary>邮政编码
  ///</summary>
  PostCode?: string;
  ///<summary>省市
  ///</summary>
  ProvinceID?: number;
  ///<summary>城市
  ///</summary>
  CityID?: number;
  ///<summary>城区
  ///</summary>
  DistrictID?: number;
  ///<summary>详细地址
  ///</summary>
  Address?: string;
  ///<summary>完整地址
  ///</summary>
  FullAddress?: string;
  ///<summary>是否默认
  ///</summary>
  IsDefault?: number;
  ///<summary>备注
  ///</summary>
  m_Remark?: string;
  ///<summary>创建时间
  ///</summary>
  CreateTime?: Date;
  CreateTimeEnd?: Date;
  ///<summary>创建人编号
  ///</summary>
  CreateUserID?: string;
  ///<summary>创建人编号
  ///</summary>
  CreateUserName?: string;
  ///<summary>修改时间
  ///</summary>
  UpdateTime?: Date;
  UpdateTimeEnd?: Date;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserID?: string;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserName?: string;
}

export class ConferInfoEntity {
  ConferID?: string;
  RoleID?: string;
  RoleName?: string;
  RoleNick?: string;
  RoleType?: number;
  RoleStatus?: number;
  RoleGenre?: number;
  BirthDate?: Date;
  BirthDateEnd?: Date;
  CreateTime?: Date;
  CreateTimeEnd?: Date;
  OwnerID?: string;
  OwnerName?: string;
  OwnerType?: number;
  OwnerStatus?: number;
  OwnerGenre?: number;
  OwnerBirth?: Date;
  OwnerBirthEnd?: Date;
  RoleWith?: number;
  OwnerWith?: number;
  OwnerCode?: string;
  SpaceID?: string;
  ConferDate?: Date;
  ConferDateEnd?: Date;
  ExpiryDate?: Date;
  ExpiryDateEnd?: Date;
  ConferStatus?: number;
  ContactPhone?: string;
  ContactEmail?: string;
  FullAddress?: string;
  ConferIDs?: string[];
  RoleIDs?: string[];
  OwnerIDs?: string[];
  OwnerCodes?: string[];
  Confers?: ConferModel[];
  Cards?: CardInfoEntity[];
  Contacts?: ContactInfoEntity[];
}
export class CompanyRoleInfo {
  RoleInfo?: RoleInfoEntity;
  SalesRepresentative?: RoleInfoEntity[];
  CusSerRepresentative?: RoleInfoEntity[];
  OtherRepresentative?: RoleInfoEntity[];
}
export class CardInfoEntity {
  ///<summary>证件编号
  ///</summary>
  CardID?: string;
  ///<summary>用户编号
  ///</summary>
  UserID?: string;
  ///<summary>证件类别
  ///</summary>
  CardType?: number;
  ///<summary>证件号码
  ///</summary>
  CardNo?: string;
  ///<summary>发证日期
  ///</summary>
  IssueDate?: Date;
  IssueDateEnd?: Date;
  ///<summary>过期日期
  ///</summary>
  ExpireDate?: Date;
  ExpireDateEnd?: Date;
  ///<summary>发证国家
  ///</summary>
  IssueCountry?: number;
  ///<summary>证件图片
  ///</summary>
  Images?: string;
  ///<summary>创建人
  ///</summary>
  CreaterID?: string;
  ///<summary>创建时间
  ///</summary>
  CreateTime?: Date;
  CreateTimeEnd?: Date;
  ///<summary>修改人
  ///</summary>
  UpdaterID?: string;
  ///<summary>修改时间
  ///</summary>
  UpdateTime?: Date;
  UpdateTimeEnd?: Date;
  ///<summary>备注
  ///</summary>
  Remark?: string;
  ///<summary>用户昵称
  ///</summary>
  RoleNick?: string;
  ///<summary>用户名称
  ///</summary>
  RoleName?: string;
  ///<summary>角色类型
  ///</summary>
  RoleType?: number;
  ///<summary>英文姓氏
  ///</summary>
  EnglishFirstName?: string;
  ///<summary>英文名称
  ///</summary>
  EnglishLastName?: string;
}

export class GrantModel {
  GrantID?: string;
  UserID?: string;
  UserAct?: string;
  Redirect?: string;
}
export class BindModel {
  AppID?: string;
  UserID?: string;
  UserAct?: string;
  UserPwd?: string;
  ValidID?: string;
  ValidCode?: string;
  Redirect?: string;
  AuthType?: number;
  ReferInfo?: ReferInfo;
  // Extras?: Dictionary<string, string>;
  Extras?: { [key: string]: string };
}
export class ExtraInfoEntity {
  ExtraID?: string;
  ///<summary>扩展名称
  ///</summary>
  ExtraName?: string;
  ///<summary>扩展数据
  ///</summary>
  ExtraData?: string;
  ///<summary>扩展代码
  ///</summary>
  ExtraCode?: string;
  ///<summary>扩展组号(扩展行记录)
  ///</summary>
  ExtraGroup?: string;
  ///<summary>格式代码(text html url json xml)
  ///</summary>
  FormatCode?: string;
  ///<summary>目标编号
  ///</summary>
  IncludeID?: string;
  ///<summary>主要信息
  ///</summary>
  MasterID?: string;
  ///<summary>额外扩展(width)
  ///</summary>
  ExtraDataX?: string;
  ///<summary>额外扩展(height)
  ///</summary>
  ExtraDataY?: string;
  ///<summary>额外扩展(depth)
  ///</summary>
  ExtraDataZ?: string;
}
export class RoleInfo {
  // private RoleInfoEntity m_RoleInfo { get; set; }
  // private ContactInfoEntity m_ContactInfo { get; set; }
  Extras?: ExtraInfoEntity[];

  Extra?: { [key: string]: object };

  RoleID?: string;

  ///<summary>角色名称
  ///</summary>
  RoleName?: string;

  ///<summary>别名
  ///</summary>
  RoleNick?: string;

  ///<summary>角色类型
  ///</summary>
  RoleType?: number;

  ///<summary>角色状态
  ///</summary>
  RoleStatus?: number;

  ///<summary>组织编号
  ///</summary>
  RootID?: string;

  ///<summary>级别代码
  ///</summary>
  LevelCode?: string;

  ///<summary>角色头像
  ///</summary>
  RoleIcon?: string;

  ///<summary>角色类型
  ///</summary>
  RoleGenre?: number;

  ///<summary>诞生日期
  ///</summary>
  BirthDate?: Date;
  BirthDateEnd?: Date;

  ///<summary>联系编号
  ///</summary>
  ContactID?: string;

  ///<summary>创建人
  ///</summary>
  CreaterID?: string;

  ///<summary>创建时间
  ///</summary>
  CreateTime?: Date;

  CreateTimeEnd?: Date;

  ///<summary>修改人
  ///</summary>
  UpdaterID?: string;

  ///<summary>修改时间
  ///</summary>
  UpdateTime?: Date;

  UpdateTimeEnd?: Date;

  ///<summary>备注
  ///</summary>
  Remark?: string;

  ///<summary>地址简称
  ///</summary>
  ContactName?: string;

  ///<summary>联系人名称
  ///</summary>
  ContactPeople?: string;

  ContactPhone?: string;

  ///<summary>联系人邮箱
  ///</summary>
  ContactEmail?: string;

  ///<summary>邮政编码
  ///</summary>
  PostCode?: string;

  ///<summary>省市
  ///</summary>
  ProvinceID?: number;

  ///<summary>城市
  ///</summary>
  CityID?: number;

  ///<summary>城区
  ///</summary>
  DistrictID?: number;

  ///<summary>详细地址
  ///</summary>
  Address?: string;

  ///<summary>完整地址
  ///</summary>
  FullAddress?: string;

  ///<summary>是否默认
  ///</summary>
  IsDefault?: number;

  ///<summary>备注
  ///</summary>
  ContactRemark?: string;

  ///<summary>创建时间
  ///</summary>
  ContactCreateTime?: Date;

  ContactCreateTimeEnd?: Date;

  ///<summary>创建人编号
  ///</summary>
  CreateUserID?: string;

  ///<summary>创建人编号
  ///</summary>
  CreateUserName?: string;

  ///<summary>修改时间
  ///</summary>
  ContactUpdateTime?: Date;
  ContactUpdateTimeEnd?: Date;

  ///<summary>修改人编号
  ///</summary>
  UpdateUserID?: string;

  ///<summary>修改人编号
  ///</summary>
  UpdateUserName?: string;
}
export class FlowInfoEntity {
  FlowID?: string;
  ///<summary>流程代码
  ///</summary>
  FlowCode?: string;
  FlowName?: string;
  ///<summary>流程归属(公司 部门 员工 用户编号 )
  ///</summary>
  OwnerID?: string;
  ApplyService?: string;
  ApplyRole?: string;
  FlowStatus?: number;
}
export class FlowNodeEntity {
  NodeID?: string;
  FlowID?: string;
  NodeName?: string;
  NodeLevel?: number;
  ///<summary>节点代码(approvals,notifys,conditions)
  ///</summary>
  NodeCode?: string;
  ///<summary>签名方式(会签 and_sign 或签 or_sign)
  ///</summary>
  SignCode?: string;

  Roles?: FlowRoleEntity[];
  Actions?: FlowActionEntity[];
}
export class FlowRoleEntity {
  RoleNodeID?: string;
  RoleID?: string;
  FlowID?: string;
  NodeID?: string;
  RoleType?: number;
  DutyCode?: string;
  RoleCode?: string;
}

export class FlowActionEntity {
  ///<summary>操作编号
  ///</summary>
  ActionID?: string;
  ///<summary>节点编号
  ///</summary>
  NodeID?: string;
  ///<summary>流程编号
  ///</summary>
  FlowID?: string;
  ///<summary>操作编号
  ///</summary>
  ActionCode?: string;
  ///<summary>操作名称
  ///</summary>
  ActionName?: string;
  ///<summary>操作类型(按钮 链接 接口)
  ///</summary>
  ActionType?: number;
  ///<summary>操作顺序
  ///</summary>
  OrderBy?: number;
  ///<summary>备注
  ///</summary>
  Remark?: string;
}

export class ReferInfo extends RoleInfo {
  ReferCodes?: string;
}

export class InvoiceInfoEntity {
  InvoiceID?: string;
  ///<summary>角色编号
  ///</summary>
  RoleID?: string;
  ///<summary>发票角色(个人 公司)
  ///</summary>
  InvoiceRole?: number;
  ///<summary>发票类型(专票 普票)
  ///</summary>
  InvoiceType?: number;
  ///<summary>发票抬头
  ///</summary>
  InvoiceTitle?: string;
  ///<summary>纳税人识别号
  ///</summary>
  IdentifyNumber?: string;
  ///<summary>银行名称
  ///</summary>
  BankName?: string;
  ///<summary>银行账号
  ///</summary>
  BankAccount?: string;
  ///<summary>公司地址
  ///</summary>
  CompanyAddress?: string;
  ///<summary>公司电话
  ///</summary>
  CompanyPhone?: string;
  ///<summary>备注
  ///</summary>
  Remark?: string;
  ///<summary>创建时间
  ///</summary>
  CreateTime?: Date;
  CreateTimeEnd?: Date;
  ///<summary>创建人编号
  ///</summary>
  CreateUserID?: string;
  ///<summary>创建人编号
  ///</summary>
  CreateUserName?: string;
  ///<summary>修改时间
  ///</summary>
  UpdateTime?: Date;
  UpdateTimeEnd?: Date;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserID?: string;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserName?: string;
}

export class ConfigInfo {
  ///<summary>配置编号
  ///</summary>
  ConfigID?: string;

  ///<summary>公司编号
  ///</summary>
  RoleID?: string;

  ///<summary>角色类型
  ///</summary>
  RoleType?: number;
  ///<summary>客户编号
  ///</summary>
  OwnerID?: string;

  ///<summary>角色类型
  ///</summary>
  OwnerType?: number;

  ///<summary>类别代码
  ///</summary>
  CategoryCode?: string;

  ///<summary>配置代码
  ///</summary>
  ConfigName?: string;

  ///<summary>配置代码
  ///</summary>
  ConfigCode?: string;

  ///<summary>配置
  ///</summary>
  ConfigValue?: string;
}

export const enum FeatureCodes {
  BusinessSupply = "business.supply",
  SystemService = "system.service",
  SystemDevelop = "system.develop",
  InitializePassword = "initialize.password",
}

export const enum StatusCode {
  /**
   * 未知错误
   */
  UNKNOWN = "unknown",
  /**
   * 成功
   */
  SUCCESS = "success",
  /**
   * 失败
   */
  FAILURE = "failure",
  /**
   * 空返回值
   */
  NOTHING = "nothing",
  /**
   *接口未授权
   */
  UNAUTHORIZED = "unauthorized",
  /**
   * 接口未定义
   */
  UNDEFINED = "undefined",
  /**
   * 服务器错误
   */
  SERVER_ERROR = "server_error",
  /**
   * 验证出错
   */
  VALIDATE_ERROR = "validate_error",
}

export const enum AuthType {
  //账号密码
  AccountAuth = 10224,
  //邮箱账号
  EmailAuth = 10220,
  //手机账号
  MobileAuth = 10222,
  //微信授权
  WeixinAuth = 10230,
  //动态密码
  DynamicAuth = 10250,
}